var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promotion)?_c('v-btn',{staticClass:"text-capitalize",attrs:{"block":"","color":_vm.color,"outlined":""},on:{"click":function($event){return _vm.setPromotion(_vm.promotion)}}},[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.selected)?_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("mdi-check")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }